import React from 'react'
import { Col, Row } from 'react-bootstrap'

function AlsoKnownAs(props) {
  const { inputData, sendinputdata, sendBooleanValueChangeDone, disableInput } = props
  const alsoKnownAsEnglish = event => {
    const inputDataTemp = { ...inputData }
    inputDataTemp.popularyKnownAs_En = event.target.value
    sendinputdata(inputDataTemp)
    sendBooleanValueChangeDone('popularyKnownAs_En', true)
    // console.log(event.target.value)
  }

  const alsoKnownAsTelugu = event => {
    const inputDataTemp = { ...inputData }
    inputDataTemp.popularyKnownAs_Te = event.target.value
    sendinputdata(inputDataTemp)
    sendBooleanValueChangeDone('popularyKnownAs_Te', true)
    // console.log(event.target.value)
  }

  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <label>PopularlyKnownAs_En</label>
            <input
              className='form-control'
              value={inputData.popularyKnownAs_En}
              type='text'
              onChange={alsoKnownAsEnglish}
              disabled={disableInput === true}
            />
          </div>
        </Col>
        {inputData && inputData.popularyKnownAs_En !== '' && (
          <Col md={6} xs={12}>
            <div>
              <label>PopularlyKnownAs_Te</label>
              <input
                className='form-control'
                value={inputData.popularyKnownAs_Te}
                type='text'
                onChange={alsoKnownAsTelugu}
                disabled={disableInput === true}
              />
            </div>
          </Col>
        )}
      </Row>
    </div>
  )
}

export default AlsoKnownAs
